export const COLORS = [
  'primary',
  'secondary',
  'tertiary',
  'quaternary',
  'gray',
  'error',
  'gradientPrimary',
  'gradientSecondary',
  'gradientTertiary',
  'white',
  'red',
  'brand'
]

export const COLOR_VARIATIONS = ['lightest', 'light', 'dark', 'darkest']

export const TEXT_SIZES = [
  'xxlg',
  'xlg',
  'mlg',
  'lg',
  'md',
  'sm',
  'xs',
  'xxs',
  'xxxs'
]

export const TEXT_WEIGHTS = ['normal', 'bold']

export const TEXT_FONT_FAMILY = ['default', 'custom']

export const BUTTON_TYPES = [
  'primary',
  'secondary',
  'tertiary',
  'quaternary',
  'outlined',
  'outlined_dark'
]

export const ENUM_COMPANY = [
  {
    company: 1,
    value: 'Santander'
  },
  {
    company: 2,
    value: 'Webmotors'
  }
]

export const FILTER_EXTRACT = [
  {
    id: 0,
    title: 'Todos'
  },
  {
    id: 1,
    title: 'Principais'
  },
  {
    id: 2,
    title: 'Satisfação'
  },
  {
    id: 3,
    title: 'Rentabilidade'
  },
  {
    id: 4,
    title: 'Vinculação'
  },
  {
    id: 5,
    title: 'Carteira'
  },
  {
    id: 6,
    title: 'Receita'
  },
  {
    id: 7,
    title: 'RiscoCredito'
  },
  {
    id: 8,
    title: 'Qualidade'
  }
]

export const INDICATOR_FORMAT_TYPE_ENUM = {
  CURRENCY: 1,
  PERCENTAGE: 2,
  INTEGER: 3,
  DECIMAL: 4,
  MULTIPLIER: 5,
  TEXT: 6,
  MILLIONS: 7,
  DATE: 8
}

export const USER_STATUS_TYPE = [
  {
    value: 1,
    label: 'Aguardando Confirmação Mobile',
    color: 'tertiary',
    check: false
  },
  {
    value: 2,
    label: 'Aguardando Confirmação E-mail',
    color: 'tertiary',
    check: false
  },
  {
    value: 3,
    label: 'Aguardando',
    color: 'tertiary',
    type: 'approve',
    check: false
  },
  {
    value: 4,
    label: 'Aguardando Primeiro acesso',
    color: 'tertiary',
    check: false
  },
  {
    value: 5,
    label: 'Recusou',
    color: 'primary',
    variation: 'light',
    check: false
  },
  {
    value: 6,
    label: 'Aguardando aceitação do termo',
    color: 'tertiary',
    check: false
  },
  {
    value: 7,
    label: 'Ativo',
    type: 'active',
    color: 'quaternary',
    check: true
  },
  {
    value: 8,
    label: 'Inativo',
    color: 'gray',
    variation: 'light',
    type: 'inactive',
    check: false
  },
  {
    value: 9,
    label: 'Pendente',
    color: 'tertiary',
    type: 'pendent',
    check: false
  }
]
